/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-useless-catch */
import { API } from "../api";
import { SERVICE_TYPES } from "../constants/url.constant";

export const GET_SERVICE_TYPES = "GET_SERVICE_TYPES";
export const GET_SERVICE_TYPE = "GET_SERVICE_TYPE";

export const getServiceTypes = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(SERVICE_TYPES, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_SERVICE_TYPES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getServiceTypeByID = (serviceCode) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${SERVICE_TYPES}/${serviceCode}`);
      dispatch({
        type: GET_SERVICE_TYPE,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateServiceType = (code, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${SERVICE_TYPES}/${code}`, body);
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { serviceTypeTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_SERVICE_TYPES:
      return {
        ...state,
        serviceTypeTableColumns: payload.columns,
        serviceTypeTableRows: payload.rows,
        totalRows: payload.count
      };
    case GET_SERVICE_TYPE:
      return {
        ...state,
        serviceDetail: payload
      };
    default:
      return state;
  }
}
